// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 17) return "static/js/b1edd5b141e2e129b378.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"43e50c41a594aaed30df","181":"0e61597f87a803b4e403","182":"d3fe69aace9520b84a12"}[chunkId] + ".chunk.js";
};